import axios from 'axios'
import Certificate from 'interfaces/Certificate'

const API_URL = process.env.REACT_APP_API_URL + '/certificates'

const headers = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'x-tenant-id': `${localStorage.getItem('tenant-id')}`,
})

const parseFilter = (filter: unknown) =>
    typeof filter === 'string' ? JSON.parse(filter) : {...(filter as object)}

const getCertificates = async (
    filter: unknown,
    pagination?: { page: number; pageSize: number }
) => {
    const parsed = parseFilter(filter)
    if (pagination?.page != null && pagination?.pageSize != null) {
        const page = Math.max(1, pagination.page)
        const pageSize = Math.max(1, pagination.pageSize)
        parsed.limit = pageSize
        parsed.skip = (page - 1) * pageSize
    }
    const qs = encodeURIComponent(JSON.stringify(parsed))
    return axios
        .get(API_URL + '?filter=' + qs, { headers: headers() })
        .then((response) => response.data)
}

const countCertificates = async (filter: unknown) => {
    const parsed = parseFilter(filter)
    const where = parsed.where !== undefined ? parsed.where : {}
    const qs = encodeURIComponent(JSON.stringify(where))
    return axios
        .get(API_URL + '/count?where=' + qs, { headers: headers() })
        .then((response) => {
            const data = response.data
            return typeof data === 'object' && data !== null && 'count' in data
                ? data.count
                : data
        })
}

const getPublicCertificates = async (filter: unknown, tenantId: string) => {
    const parsed = parseFilter(filter)
    const qs = encodeURIComponent(JSON.stringify(parsed))
    return axios
        .get(API_URL + '?filter=' + qs, {
            headers: { 'x-tenant-id': tenantId },
        })
        .then((response) => response.data)
}

const getCertificate = async (id: string) => {
    return axios
        .get(API_URL + '/' + id, { headers: headers() })
        .then((response) => response.data)
}

const saveCertificate = async (certificate: Certificate) => {
    return axios
        .post(API_URL, certificate, { headers: headers() })
        .then((response) => response.data)
}

const patchCertificate = (id: string, certificate: Certificate) => {
    return axios
        .patch(API_URL + '/' + id, certificate, { headers: headers() })
        .then((response) => response.data)
}

const exportedMethods = {
    getCertificate,
    getPublicCertificates,
    getCertificates,
    countCertificates,
    patchCertificate,
    saveCertificate,
}

export default exportedMethods
